<div class="landing-container" [class.mobile]="isMobile()">
  <div class="landing-content">
    <!-- Logo Section -->
    <!-- Hidden test-mode gesture: kept out of the tab order on purpose (visible login button is the accessible path) -->
    <div class="logo-section" (click)="onLogoTap()" (keyup.enter)="onLogoTap()" tabindex="-1">
      <img class="app-logo" src="assets/img/512x512-logoABVVFGTB.jpg" alt="ABVV-FGTB" />
      <h1 class="app-title">{{ 'AUTH.LANDING_APP_TITLE' | translate }}</h1>
      <p class="app-subtitle">{{ 'AUTH.LANDING_SUBTITLE' | translate }}</p>

      <!-- Test Mode Badge -->
      @if (testModeEnabled()) {
        <div class="test-mode-badge">
          {{ 'AUTH.TEST_MODE_ACTIVE' | translate }}
        </div>
      }
    </div>

    <!-- Welcome Message -->
    <div class="welcome-section">
      <h2 class="welcome-title">{{ 'AUTH.LANDING_WELCOME_TITLE' | translate }}</h2>
      <p class="welcome-text">{{ 'AUTH.LANDING_WELCOME_TEXT' | translate }}</p>
    </div>

    <!-- Action Buttons -->
    <div class="action-section">
      <!-- Normal Login (shown when test mode is disabled) -->
      @if (!testModeEnabled()) {
        <button
          class="btn btn-primary btn-login"
          (click)="onLogin()"
          [disabled]="isLoading()"
          type="button"
          >
          @if (!isLoading()) {
            <span>{{ 'AUTH.LANDING_LOGIN' | translate }}</span>
          }
          @if (isLoading()) {
            <span class="loading-spinner">
              <i class="fa fa-spinner fa-spin"></i> {{ 'AUTH.LANDING_LOADING' | translate }}
            </span>
          }
        </button>
      }

      <!-- Test Login Form (shown when test mode is enabled) -->
      @if (testModeEnabled()) {
        <div class="test-login-section">
          <form [formGroup]="testLoginForm" (ngSubmit)="loginAsTest()">
            <div class="form-field">
              <label for="testUsername">{{ 'AUTH.TEST_ACCOUNT_USERNAME' | translate }}</label>
              <input
                id="testUsername"
                type="text"
                formControlName="username"
                class="test-input"
                placeholder="apple-tester">
            </div>

            <div class="form-field">
              <label for="testPassword">{{ 'AUTH.TEST_ACCOUNT_PASSWORD' | translate }}</label>
              <input
                id="testPassword"
                type="password"
                formControlName="password"
                class="test-input"
                placeholder="••••••••">
            </div>

            @if (testLoginError()) {
              <div class="test-login-error">{{ testLoginError() }}</div>
            }

            <button
              type="submit"
              class="test-login-button"
              [disabled]="!testLoginForm.valid || isTestLoading()">
              @if (isTestLoading()) {
                <i class="fa fa-spinner fa-spin"></i> Loading...
              } @else {
                {{ 'AUTH.LOGIN_AS_TESTER' | translate }}
              }
            </button>

            <a class="cancel-link" role="button" tabindex="0" (click)="cancelTestMode()" (keyup.enter)="cancelTestMode()">
              {{ 'AUTH.USE_NORMAL_LOGIN' | translate }}
            </a>
          </form>
        </div>
      }
    </div>

  </div>
</div>
